import React from 'react';
import { Backdrop, Box } from '@mui/material';
import { keyframes } from '@emotion/react';

const pulseAnimation = keyframes`
  0% {
    transform: scale(0.95);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.9;
  }
  100% {
    transform: scale(0.95);
    opacity: 0.7;
  }
`;

function LoadingOverlay({ open }) {
  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: 9999,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        backdropFilter: 'blur(3px)',
      }}
    >
      <Box
        sx={{
          animation: `${pulseAnimation} 2s ease-in-out infinite`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src="/LOGO-VAI-PRA-CONTA-EDITADA (1).png"
          alt="Loading..."
          style={{ width: '200px' }}
        />
      </Box>
    </Backdrop>
  );
}

export default LoadingOverlay;
